/**
 * When there is a `textarea` type attribute on an object, the user can enter rich text that
 * is saved and transferred as raw HTML. Because of this, we need to sanitize the input
 * before rendering it to prevent XSS. The below is the allowlist of HTML tags we're expecting
 * to receieve from the editor. All other tags will be stripped out before rendering.
 */
export const ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS = [
	'p',
	'u',
	'a',
	'em',
	'strong',
	'span',
	'ol',
	'ul',
	'li',
	'pre',
	'code',
	'h2',
	'h3',
	'h4',
	'hr',
	'table',
	'thead',
	'tbody',
	'tr',
	'th',
	'td',
] as const;

// these currently correspond to the current formats defined in the existing Insight legacy ui
// used in the context of the datetime object attribute type
export const DATE_VALUE_FORMAT = 'yyyy-MM-dd';
export const TIME_VALUE_FORMAT = 'HH:mm';
export const ZONE_VALUE_FORMAT = 'XXX';

// format currently used for dates displayed in the insight ui e.g created date of an attachment
export const GENERAL_DATE_TIME_FORMAT = 'dd/MMM/yy h:mm a';

export const SCREEN_READER_DATE_TIME_FORMAT = 'do MMMM Y h:mm a';

export const globalErrorContexts = [
	'objectsLimit',
	'objectTypeAttributesLimit',
	'objectSchemaLimit',
] as const;

export const MAX_OBJECT_COUNT_CUTOFF = 1000;
